export default {
  draft: {
    id: 1,
    name: "Onboarding",
    tag_type: "info",
  },
  pending_approval: {
    id: 2,
    name: "Sent for Approval",
    tag_type: "warning",
  },
  approved: {
    id: 3,
    name: "Approved",
    tag_type: "success",
  },
  declined: {
    id: 4,
    name: "Declined",
    tag_type: "danger",
  },
  lost: {
    id: 5,
    name: "Lost",
    tag_type: "warning",
  },
  archived: {
    id: 6,
    name: "Archived",
    tag_type: "danger",
  },
};
